import { Retriever } from "../Retriever";
import { observable, Lambda, observe, action } from "mobx";
import * as SParsers from "./SportParsers";
import { ScoreboardType } from "../Constants";
import { ScoreboardDataType } from "../interfaces";
import { LiveMasterEventLegacy } from "sb-resp-lib";

export class Parser {
    retriever: Retriever;
    scoreboardType: string;
    @observable scoreboardData: ScoreboardDataType;
    backgroundImg: string;
    private disposeScoreboardData: Lambda;

    constructor (retriever:Retriever) {
        this.retriever = retriever;
        this.scoreboardType = ScoreboardType.Baseball;// change to be received from the BE once more scoreboards are implemented
        this.scoreboardData = {} as ScoreboardDataType;
        this.backgroundImg = retriever.backgroundImg;
        this.disposeScoreboardData = () => {};
    }

    activate() {
        this.disposeScoreboardData = observe(this.retriever, "liveMasterEvent", change => {
            this.setScoreboardData(this.parseToModel(change.newValue));
        });

        this.retriever.activate();
    }

    deactivate() {
        this.retriever.deactivate();
        this.disposeScoreboardData();
    }

    @action.bound setScoreboardData(data:ScoreboardDataType) {
        this.scoreboardData = data;
    }

    parseToModel(event: LiveMasterEventLegacy): ScoreboardDataType {
        let result = {};
        if (event === undefined || event.BaseballScoreBoardInfo === undefined) {
            return result as ScoreboardDataType;
        }

        if (typeof SParsers[this.scoreboardType] === "function") {
            result = SParsers[this.scoreboardType](event);
        }

        return result as ScoreboardDataType;
    }
}